//Mahesh S : 17-08-2023 : BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings- Start
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BzButton, BzCard, BzChip, BzInputText, BzScrollContainer } from '../../../../../components';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ALL_ORDERS_STATUS, ORDERS_TABKEY, ORDER_TYPES, SESSION_STORAGE_KEYS, TL_INDEX } from '../../../../../utils/global_variables';
import { StatusChip } from '../../../../Orders';
import ZeroStates from '../../../../ZeroStates';
import { handleModal, handleModalData } from '../../../../../redux/actions/modals';
import { getWfhTouchlineLastTick } from '../../../../../redux/actions/wfh';
import { useUnload, useWFHMessages } from '../../../../../hooks';
import { sendTouchlineRequest } from '../../../../../apis/web_socket';
import { _getProductType, ordersFilters } from '../../../../../controllers/netPosition';
import { updateFilters } from '../../../../../redux/actions/orders';
import { _getOrderDisplayStatus } from '../../../../../controllers';
import moment from 'moment';
import { getQtyType, handleScripUnsubScriptionOnUnMount } from '../../../../../utils/global_functions';

const Spread = ({ handlePlaceOrder }) => {

    const dispatch = useDispatch();
    const spreadOrders = useSelector(state => state?.orders?.arrSpreadAllOrders);
    const getMultiScripOrder = useSelector(state => state.orders.orderTypes[1].data);
    const modalData = useSelector(state => state.modals?.modalData);
    const holdingsScrips = useSelector(state => state.holdings?.holdingsScrips);
    const objFilterData = useSelector(state => state?.orders?.objFilterData);

    // const spreadOrders = 
    // const { allOrders, allCompletedOrders, allOpenOrders } = useSelector(state => state?.orders?.getSpreadOrder);
    //useMemo(() => getMultiScripOrder?.filter((each) => each?.orderType === 'Spread'), [getMultiScripOrder]);

    const [arrOrders, setArrOrders] = useState([]);
    const [searchText, setSearchText] = useState();
    const [isSearchShoing, setIsSearchShowing] = useState(true);
    const productTypeData = useSelector(state => state?.orders?.productTypes);
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    const navigate = useNavigate();
    let containerRef = useRef();

    useEffect(() => {
        if (spreadOrders && spreadOrders?.length > 0)
            setArrOrders(spreadOrders);
    }, [spreadOrders]);



    const handleMultiScripLtp = useCallback((arrTouchLineData) => {
        let copyArrOrders = spreadOrders;
        if (spreadOrders && spreadOrders?.length > 0) {
            spreadOrders?.forEach((each, i) => {
                if (each?.segment_id + "_" + each?.spread_token + "_" + each?.order_id === arrTouchLineData[TL_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX.TOKEN] + "_" + each?.order_id) {
                    const objScripToBeUpdated = each;
                    objScripToBeUpdated.ltp = arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE];
                    if (Object.keys(objScripToBeUpdated)?.length > 0) {
                        copyArrOrders[i] = objScripToBeUpdated;
                        setArrOrders([...copyArrOrders]);
                    } else { }
                } else { }
            });
        } else { }
    }, [arrOrders, spreadOrders]);

    useWFHMessages('touchline', (e) => {
        const arrTouchlineReq = [...e.detail];
        handleMultiScripLtp(arrTouchlineReq);
    });


    const onSearchChange = (value) => {
        setSearchText(value);
    };

    const onSearchClose = () => {
        setSearchText();
        setIsSearchShowing(true);
    };

    // Hari K:08-01-2024: BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ -start
    const filteredData = useMemo(() => {
        if (modalData?.filter !== undefined) {
            if (Object?.keys(modalData?.filter)?.length > 0) {
                const filteredArray = ordersFilters(modalData?.filter, arrOrders);
                return filteredArray;
            } else { }
        } else { }
        if (arrOrders?.length > 0) {
            if (searchText?.length > 0) {
                const filteredPositions = arrOrders?.filter((each) => each?.spread_symbol?.toLowerCase().includes(searchText?.toLowerCase()));
                return filteredPositions;
            } else {
                return arrOrders;
            }
        } else { return []; } /* Parshva S: BT: 107070 : 2/3/24 */
    }, [searchText, modalData, arrOrders]);

    const chechOrdersStatus = useCallback(() => {
        return filteredData?.every((obj) => obj?.status?.toUpperCase() === ALL_ORDERS_STATUS.ORDER_STATUS_COMPLETED || obj?.status?.toUpperCase() === ALL_ORDERS_STATUS.ORDER_STATUS_EXECUTED);
    }, [filteredData]);
    // Hari K:08-01-2024: BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ -end

    // Vinit R : 12-03-2024 : NSE FAO Watchlist Sidetray - Orders, Positions and Holdings -- Start
    const allExchangeList = [...new Set(spreadOrders?.map(element => element?.exchangeName?.split('_')[0]))];
    const allProductType = [...new Set(spreadOrders?.map(element => element?.exchangeWiseProductType ? element?.exchangeWiseProductType : _getProductType(element?.leg_no_1?.product_type, element?.exchange, productTypeData, objLoginSession)))];
    const orderStatusFilters = [...new Set(spreadOrders?.map(orders => _getOrderDisplayStatus(orders?.status)))];
    // Parshva S : 20/03/2024 : BT 107070 Breeze Spread Orders Start
    const handleOrderHistory = (id) => {
        const path = `/orders?section=${ORDER_TYPES.SPREAD}&ordertype=${ORDERS_TABKEY.ALL_ORDERS}`;
        navigate(path, { state: id });
        sessionStorage.setItem(SESSION_STORAGE_KEYS.SEARCH_PARAMS, 'true');
    };
    // Parshva S : 20/03/2024 : BT 107070 Breeze Spread Orders End
    const handleFilters = () => {
        if (spreadOrders?.length) {
            dispatch(handleModal([{ "FILTER_ORDER_POSITION_MODAL": true }]));
            dispatch(handleModalData({ type: 'Orders', allExchangeList: allExchangeList, allProductType: allProductType, orderStatusFilters }));
        }
    };
    // Vinit R : 12-03-2024 : NSE FAO Watchlist Sidetray - Orders, Positions and Holdings -- End

    const handleClickChips = (ele) => {
        delete objFilterData[ele];
        dispatch(handleModalData({ filter: objFilterData }));
        dispatch(updateFilters(objFilterData));
    };

    const startObserving = () => {
        return new Promise((resolve) => {
            const observer = new IntersectionObserver((entries) => {
                const visible = entries?.filter((entry) => entry?.isIntersecting)?.map((entry) => entry?.target?.id);
                resolve(visible);
            }, {
                root: containerRef?.current,
                threshold: 0.1
            });
            const container = containerRef?.current;
            if (container) {
                Array?.from(container?.children[0].children[0]?.children[0]?.children[0]?.children)?.forEach((child) => observer?.observe(child));
            }
        });

    };

    const [objScripsRequest, setObjScripsRequest] = useState({});
    const handleSideBArSpreadScripOrders = useCallback(async () => {
        let dahsboardWatchlistData = await startObserving();
        setObjScripsRequest(prevState => {
            let objpreviosScripsCopy = prevState;
            let arrWithKeys = [];
            let subscribeScrips = []; // This array is a non repeated subscrips for subscription
            let unSubScribeScrips = []; // this array is scrips of unsubscription]

            const arrVisibleRows = dahsboardWatchlistData.map(item => {
                let id = item;
                arrWithKeys?.push(id);
                if (!objpreviosScripsCopy[id]) {
                    objpreviosScripsCopy[id] = true;
                    subscribeScrips?.push({ exchangeId: Number(item?.split("_")[0]), token: Number(item?.split("_")[1]), isSubscribe: true });

                }
                return { exchangeId: Number(item?.split("_")[0]), token: Number(item?.split("_")[1]), isSubscribe: true };
            });
            Object?.keys(objpreviosScripsCopy)?.forEach(key => {
                if (!arrWithKeys.includes(key)) {
                    let obj = {
                        exchangeId: Number(key?.split('_')[0]),
                        token: Number(key?.split('_')[1]),
                        isSubscribe: false
                    };
                    unSubScribeScrips?.push(obj);
                    delete objpreviosScripsCopy[key];
                }
            });
            sendTouchlineRequest(unSubScribeScrips);
            sendTouchlineRequest(subscribeScrips);
            setTimeout(() => {
                const objLastTickData = dispatch(getWfhTouchlineLastTick());
                if (Object.keys(objLastTickData).length > 0) {
                    arrVisibleRows?.forEach((each) => {
                        const arrLastTickData = objLastTickData[each?.exchangeId + "_" + each?.token];
                        if (arrLastTickData?.length > 0) {
                            handleMultiScripLtp(arrLastTickData);
                        }
                    });
                }
            }, 1000);
            return { ...objpreviosScripsCopy };
        });
    }, []);

    const handleScrollOfOrders = useCallback((event) => {
        handleSideBArSpreadScripOrders();
    }, [handleSideBArSpreadScripOrders]);

    useEffect(() => {
        if (spreadOrders?.length > 0) {
            handleSideBArSpreadScripOrders();
        }
    }, [spreadOrders]);


    const handleSideSpreadOrdersUnSubscription = useCallback(() => {
        handleScripUnsubScriptionOnUnMount(objScripsRequest, 'Side bar spread scrip');
    }, [objScripsRequest]);


    useUnload(() => {
        handleSideSpreadOrdersUnSubscription();
    });

    return (
        <>
            <Container fluid className='p-0 px-3'>
                <Row className='g-0 py-1 mb-2 align-items-center h_40'>
                    <Col md={3} className='d-flex justify-content-start align-items-center'>
                        <Link to={!chechOrdersStatus() ? `/orders?section=spreadorderscancel` : null}>
                            <BzButton className='btn btn-sm btn-outline text-truncate' disabled={chechOrdersStatus()}>Cancel All</BzButton>
                        </Link>
                    </Col>
                    <Col md={9} className='d-flex justify-content-end align-items-center'>
                        {isSearchShoing === true ?
                            <div onClick={() => spreadOrders?.length ? setIsSearchShowing(false) : null} className={`icon-16 icon-search ${spreadOrders?.length ? 'icon-dark' : 'icon-grey'}`}></div>
                            : <>
                                <div className='position-relative w-70'>
                                    <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                    <BzInputText autoFocus onChange={(e) => onSearchChange(e.target.value)} size='sm' type='search' placeholder="Search Scrips" className='p-l-30 font-regular scripname-searchtext'></BzInputText>
                                </div>
                                <div className='icon-16 icon-dark icon-close ms-2' onClick={() => onSearchClose()} />
                            </>}

                        <div className={`icon-16 icon-searchfilter ${spreadOrders?.length ? 'icon-dark' : 'icon-grey'} ms-3`} onClick={handleFilters}></div>
                        <Link to='/orders?section=spread'>
                            <div className='icon-14 icon-redirect icon-dark ms-3'></div>
                        </Link>
                    </Col>
                </Row>
                {Object.keys(objFilterData)?.length ?
                    <Row className='g-0 mb-3'>
                        <Col className='d-flex'>
                            <div className='font-medium font-size2 color-text m-1'>Filters:</div>
                            <div className='horizontal-scroll-wrap filters-chips-wrap flex-nowrap'>
                                {Object.keys(objFilterData)?.map((ele, i) => {
                                    return <div key={i} className='chips chips default-chip text-capitalize m-1'>
                                        {objFilterData[ele] === "low_high" ? `${ele} : Low-High` : objFilterData[ele] === "high_low" ? `${ele} : High-Low` : parseFloat(objFilterData[ele]) ? `${ele.slice(-3)} : ${objFilterData[ele]}` : `${ele} : ${objFilterData[ele]}`} <div style={{ width: "6px", height: '6px', marginLeft: "6px" }} onClick={handleClickChips?.bind(this, ele)} className='icon-16 icon-dark icon-close'></div>
                                    </div>;
                                })
                                }
                            </div>
                        </Col>
                    </Row>
                    : null
                }
            </Container>
            {/* //Vaibhav Singh: 05-02-24: BT-107431: Updated Filter Lofic : End */}
            {spreadOrders?.length > 0 && filteredData?.length > 0 ?
                <Container fluid className='p-0'>
                    <BzScrollContainer className='sticky-orderpositions-height px-3' onScrollEnd={(e) => handleScrollOfOrders(e)} contaierref={containerRef}>
                        <Row className='g-0'>
                            <Col>
                                <div className='p-0'>
                                    <div className='transparent-card-wrap mb-2'>
                                        {/* ManasaB : 10-09-2024 : Hotfix issue  - Start*/}
                                        {filteredData.length > 0 ? filteredData?.map((each, i) => (
                                            <>
                                                <BzCard key={i} id={each?.segment_id + '_' + each?.spread_token} className='transparent-card cursor-pointer bdr-btm' onClick={() => { handleOrderHistory(each?.order_id); }} >
                                                    <Row className='g-0'>
                                                        <Col md={6} className='d-flex justify-content-start align-items-center'>
                                                            <div className='font-medium font-size3 color-text text-uppercase me-2'>{each?.spread_symbol}</div>
                                                            <div className='chips-wrap'>
                                                                <BzChip className='exchange-chip'>{each?.exchange === 'NSE_CUR' ? "NSECDS" : each?.exchange === 'BSE_CUR' ? "BSECDS" : each?.exchange?.split('_')[0]} </BzChip>
                                                            </div>
                                                        </Col>
                                                        <Col md={6} className='orderstatus-chips-wrap d-flex justify-content-end align-items-center'>
                                                            <StatusChip isSpreadMultiLegStatusChip={true} data={each} strClass='d-flex justify-content-end align-items-center' />
                                                        </Col>
                                                    </Row>
                                                    {/* <Row className='g-0'>
                                                        <Col md={2} className='d-flex justify-content-end align-self-center'>
                                                            {each?.order_id == memo ? < div className='icon-10 icon-arrowup icon-dark ms-2' onClick={() => setMemo(null)}></div> : < div className='icon-10 icon-arrowdown icon-dark ms-2' onClick={() => { setMemo(each?.order_id); }}></div>}
                                                        </Col>
                                                    </Row> */}
                                                    <Row className='g-0 mb-1'>
                                                        <Col className='d-flex'>
                                                            {/* {dontMissData?.some(element => element[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === each?.MktSegId + '_' + each?.nToken)
                                                                ?
                                                                <div className='icon-16 icon-dontmiss icon-yellow ms-2'></div> : null} */}
                                                            {(holdingsScrips?.some(element => element?.nMarketSegmentId + '_' + element?.nToken === each?.MktSegId + '_' + each?.nToken) ?
                                                                <div className='icon-16 icon-portfolio icon-dark ms-2'></div> : null)}
                                                            <div className='font-regular font-size2 color-subtext text-uppercase'>                                                                    {moment(each?.leg_no_1?.expiry_date).format('MMM')?.toUpperCase()}-{moment(each?.leg_no_2?.expiry_date).format('MMM')?.toUpperCase()} {moment(each?.leg_no_1?.expiry_date).format("DD MMM 'YY")?.toUpperCase()} {each?.instrument} {each?.leg_no_1?.instrument?.split("STK").join('')}</div>
                                                        </Col>
                                                    </Row>
                                                    <Row className='g-0 mb-1'>
                                                        <Col md={8} className='d-flex justify-content-start align-self-center'>
                                                            {/* // Parshva S : 20/03/2024 : BT 107070 Breeze Spread Orders Start */}
                                                            <div className='font-regular font-size3 color-text'>
                                                                <span className={`font-medium font-size2 color-text ${each?.leg_no_1?.transaction_type === 'BUY' ? 'color-positive' : 'color-negative'} `}>
                                                                    {each?.leg_no_1?.transaction_type}</span>-<span className={`font-medium font-size2 color-text ${each?.leg_no_2?.transaction_type === 'BUY' ? 'color-positive' : 'color-negative'} `}>
                                                                    {each?.leg_no_2?.transaction_type}</span>: {each?.leg_no_1?.total_quantity} {getQtyType(each?.exchangeName)} @ ₹{each?.leg_no_1?.order_price}
                                                            </div>
                                                            {/* // Parshva S : 20/03/2024 : BT 107070 Breeze Spread Orders End */}
                                                        </Col>
                                                        <Col md={4} className='d-flex justify-content-end align-self-center'>
                                                            <div className='font-regular font-size2 color-subtext'>
                                                                <span className='font-medium color-text'>{each?.leg_no_1?.traded_quantity}/{each?.leg_no_1?.total_quantity}</span> {getQtyType(each?.exchangeName)}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className='g-0 mb-1'>
                                                        <Col md={6} className='chips-wrap'>
                                                            <div className='d-flex justify-content-start align-self-center'>
                                                                <div className='chips-wrap'>
                                                                    <BzChip className='chips primary-chip text-capitalize'>{each?.prod_type}</BzChip>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col md={6} className='d-flex justify-content-end align-self-center'>
                                                            <div className='font-regular font-size2 color-text text-end'>
                                                                <span className='color-subtext'>LTP: </span>{each?.ltp}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className='g-0'>
                                                        <Col md={6} className='d-flex justify-content-start align-self-center'>
                                                            <div className='d-flex align-self-center font-regular font-size1 color-subtext me-2'>{moment(each?.order_modified_timestamp).format("hh:mm:ss A, DD MMM 'YY").toUpperCase()}</div>
                                                        </Col>
                                                        {/* <Col md={6} className='d-flex justify-content-end align-self-center'>
                                                            <div className='chips-wrap'>
                                                                <StatusChip data={each} />
                                                            </div>
                                                        </Col> */}
                                                    </Row>
                                                </BzCard>
                                            </>
                                        )) :
                                            <div className='zero-state-alerts zero-state-alerts-xl'>
                                                <div className='icon-64 icon-nodata mrgauto mb-3'></div>
                                                <div className='font-medium font-size4 color-text mb-1'>No matches found</div>
                                                <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
                                            </div>
                                        }
                                        {/* ManasaB : 10-09-2024 : Hotfix issue  - End*/}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </BzScrollContainer>
                </Container>
                :
                <div className='zero-state-alerts zero-state-alerts-xl'>
                    <ZeroStates subText="No orders available" icon='icon-100 icon-nodata mb-2 mrgauto' />
                </div>
            }
        </>
    );
};

export default Spread;

//Mahesh S : 17-08-2023 : BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings- End
